import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt } from '@fortawesome/pro-regular-svg-icons'
import { lib } from '@gocanvas/client'
const { referenceDataHooks } = lib
const { useReferenceDataColumn } = referenceDataHooks

export const ReferenceDataPreview = ({
  reference_data_id,
  reference_data_column,
  data_source_context_id,
  live_data_source_column,
  showDuplicates = false,
}) => {
  const {
    name,
    columnIndex = 0,
    rows = [],
  } = useReferenceDataColumn({
    reference_data_id,
    reference_data_column,
    data_source_context_id,
    live_data_source_column,
  })

  const seenValues = new Set()

  const hasColumn = reference_data_column || live_data_source_column

  return (
    <>
      <div className="option--input option--ref-data">
        <div className="fa-ref-data-icon--wrapper">
          <FontAwesomeIcon icon={faBolt} className="label--icon" />
        </div>
        <div className="option--label">{name}</div>
      </div>
      {hasColumn &&
        rows.map((row, i) => {
          const { [columnIndex]: value } = row
          const seen = !showDuplicates && seenValues.has(value)
          if (!value || seen) {
            return null
          }
          if (!showDuplicates) {
            seenValues.add(value)
          }
          return (
            <div
              key={`${reference_data_id}-row-${i}`}
              className="option--input"
            >
              <div className="option--label">{value}</div>
            </div>
          )
        })}
    </>
  )
}
